import { render } from "./vresourcesclassify.vue?vue&type=template&id=054a64e7&scoped=true"
import script from "./vresourcesclassify.vue?vue&type=script&lang=js"
export * from "./vresourcesclassify.vue?vue&type=script&lang=js"

import "./vresourcesclassify.vue?vue&type=style&index=0&id=054a64e7&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054a64e7"]])

export default __exports__